module.exports = __webpack_public_path__ + "img/dc6bda88723ce9dfaa82de5c9e19191f.07865a35.jpg";